import { WindVaneAnimatic } from '@crossnokaye/ux-animatics';

import {
  ANIMATIC_PRIMARY_LABEL,
  ANIMATIC_SECONDARY_LABEL,
} from '@/features/equipment-browser/animatics/animatics.constants';
import { getLabel } from '@/features/equipment-browser/animatics/animatics.helpers';
import { degreesFromRef } from '@/features/equipment-browser/utils';

import { AnimaticConfigProps } from './types';
import { ScaledAnimatic } from '../scaled-animatic';

export const AnimaticWindVane = ({ config, labels, state, className }: AnimaticConfigProps) => {
  const windVaneConfig = config.specificAnimaticConfig?.windVane;
  const windDirectionRef = windVaneConfig?.windDirectionRef;
  const vaneOrientationRef = windVaneConfig?.vaneOrientationRef;

  const windDirection = degreesFromRef(windDirectionRef);
  const orientation = degreesFromRef(vaneOrientationRef);

  const primaryLabel = getLabel(labels, ANIMATIC_PRIMARY_LABEL);
  const secondaryLabel = getLabel(labels, ANIMATIC_SECONDARY_LABEL);

  return (
    <ScaledAnimatic className={className} scaleX={1} scaleY={1}>
      <WindVaneAnimatic
        orientation={orientation}
        primaryLabel={primaryLabel?.text}
        secondaryLabel={secondaryLabel?.text}
        state={state}
        windDirection={windDirection}
      />
    </ScaledAnimatic>
  );
};
